import { atom } from 'jotai'

import { api } from '../lib/api'

export const safetyErrorAtom = atom<string | null>(null)
export const safetyIsLoadingAtom = atom(false)

export const blockUserAtom = atom(
  null,
  async function blockUser(_get, set, payload: { userId?: string; profileId?: string }) {
    set(safetyIsLoadingAtom, true)
    set(safetyErrorAtom, null)

    try {
      const response = await api.fetch('/blocks', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })

      if (!response.ok) {
        set(safetyErrorAtom, 'Failed to block user')
        set(safetyIsLoadingAtom, false)
        return { success: false as const }
      }

      set(safetyIsLoadingAtom, false)
      return { success: true as const }
    } catch {
      set(safetyErrorAtom, 'Network error')
      set(safetyIsLoadingAtom, false)
      return { success: false as const }
    }
  },
)

export const reportUserAtom = atom(
  null,
  async function reportUser(
    _get,
    set,
    payload: { profileId: string; reason: string; details?: string },
  ) {
    set(safetyIsLoadingAtom, true)
    set(safetyErrorAtom, null)

    try {
      const response = await api.fetch('/reports', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })

      if (!response.ok) {
        set(safetyErrorAtom, 'Failed to submit report')
        set(safetyIsLoadingAtom, false)
        return { success: false as const }
      }

      set(safetyIsLoadingAtom, false)
      return { success: true as const }
    } catch {
      set(safetyErrorAtom, 'Network error')
      set(safetyIsLoadingAtom, false)
      return { success: false as const }
    }
  },
)

export const deleteAccountAtom = atom(null, async function deleteAccount(_get, set) {
  set(safetyIsLoadingAtom, true)
  set(safetyErrorAtom, null)

  try {
    const response = await api.fetch('/users/me', { method: 'DELETE' })
    if (!response.ok) {
      set(safetyErrorAtom, 'Failed to delete account')
      set(safetyIsLoadingAtom, false)
      return { success: false as const }
    }

    set(safetyIsLoadingAtom, false)
    return { success: true as const }
  } catch {
    set(safetyErrorAtom, 'Network error')
    set(safetyIsLoadingAtom, false)
    return { success: false as const }
  }
})
